import { FormType } from '../../../form-types';
import { PeptideQuestionFieldAnswers } from './questions';

export const peptide: FormType<PeptideQuestionFieldAnswers> = {
  name: 'Peptide',
  questions: [
    {
      key: 'peptide_interest',
      next: {
        condition: { 'peptide_interest.not_interested': true },
        key: 'peptide_ineligible',
        els: 'peptide_sexAssignedAtBirth'
      }
    },
    {
      key: 'peptide_sexAssignedAtBirth',
      next: {
        condition: { 'peptide_sexAssignedAtBirth.female': true },
        key: 'peptide_pregnancy',
        els: 'generic_heightWeight2025'
      }
    },
    {
      key: 'peptide_pregnancy',
      next: {
        condition: { 'peptide_pregnancy.yes': true },
        key: 'peptide_ineligible',
        els: 'peptide_pregnancyConsent'
      }
    },
    {
      key: 'peptide_pregnancyConsent',
      next: {
        condition: { 'peptide_pregnancyConsent.non_consent': true },
        key: 'peptide_didNotConsent',
        els: 'generic_heightWeight2025'
      }
    },
    'generic_heightWeight2025',
    'peptide_therapyGoals',
    'peptide_symptoms',
    {
      key: 'peptide_conditions',
      next: {
        condition: { 'peptide_conditions.none_of_the_above': true },
        key: 'peptide_regimen',
        els: 'peptide_ineligible'
      }
    },
    {
      key: 'peptide_regimen',
      next: {
        condition: { 'peptide_regimen.yes': true },
        key: 'peptide_regimenDetails',
        els: 'peptide_otherInformation'
      }
    },
    'peptide_regimenDetails',
    'peptide_otherInformation',
    {
      key: 'peptide_treatmentConsent',
      next: {
        condition: { 'peptide_treatmentConsent.non_consent': true },
        key: 'peptide_didNotConsent',
        els: 'peptide_complete'
      }
    },
    'peptide_complete',
    'peptide_ineligible',
    'peptide_didNotConsent'
  ]
};
